import classNames from "classnames";
import Styles from "./Jumbotron.module.scss";

const Jumbotron = ({ img, text }) => {
  return (
    <div className={classNames("col-12", Styles.jumnotron)}>
      <div
        className={classNames("col-12", Styles.jumnotron)}
        style={{
          backgroundImage: `url(${img})`,
          backgroundPosition: "bottom",
          backgroundSize: "cover",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        <div className={classNames(Styles.jumnotron__overlay)}>{text}</div>
      </div>
    </div>
  );
};
export default Jumbotron;
